<template>
    <div class="survey-review-link">
        <div
            v-if="!showGoReviewButton"
            class="survey-review-link--before-click"
        >
            <img :src="ReviewGreenExclamation" />
            <Typography variant="body1">{{ requestTitle }}</Typography>
            <button
                class="survey-review-link--button"
                :data-url="item.link"
                @click="copyComment(item.link)"
            >
                <img :src="ReviewCopyIcon" />
                <Typography variant="body2">{{ btnTitle }}</Typography>
            </button>
        </div>
        <div v-if="showGoReviewButton" class="survey-review-link--after-click">
            <img :src="ReviewGreenCheck" />
            <Typography variant="body1">{{ confirmationMessage }}</Typography>
            <button
                class="survey-review-link--button"
                :data-url="item.link"
                @click="visitReviewPage(item.link)"
            >
                <img :src="ReviewGoIcon" />
                <Typography variant="body2">GO NOW</Typography>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
// customer face survey form component
import { onMounted, ref } from 'vue'
import { ReceiveText } from '@/entities/conversation'
import Typography from '@/components/Rain/Typography/Typography.vue'
import ReviewCopyIcon from '@/assets/img/Icons/White/review-copy.svg'
import ReviewGoIcon from '@/assets/img/Icons/White/review-go.svg'
import ReviewGreenCheck from '@/assets/img/Icons/Green/review-check.svg'
import ReviewGreenExclamation from '@/assets/img/Icons/Green/review-exclamation.svg'
import { copyToClipboard } from '@/utils/function'
import { trackReviewLinkClicked } from '@/api/conversation'
import {
    SurveyDisplayValues,
    REVIEW_LINK_DEFAULT_TITLE,
    REVIEW_LINK_DEFAULT_BTN_TITLE,
    REVIEW_LINK_DEFAULT_CONFIRM_MESSAGE,
} from '@/entities/conversation'

interface Props {
    item: ReceiveText
    surveyDisplayValues?: SurveyDisplayValues
    slug: string
}
const props = defineProps<Props>()

const showGoReviewButton = ref(false)
const countdownSeconds = ref(3)
const shortlinkSlug = ref('')
const requestTitle = ref(props.item.title || REVIEW_LINK_DEFAULT_TITLE)
const btnTitle = ref(props.item.btnTitle || REVIEW_LINK_DEFAULT_BTN_TITLE)
const confirmationMessage = ref(
    props.item.confirmationMessage || REVIEW_LINK_DEFAULT_CONFIRM_MESSAGE
)
const reviewComment = ref('')

const emit = defineEmits(['callNext'])

onMounted(async () => {
    reviewComment.value = props.surveyDisplayValues?.comment as string

    setTimeout(() => {
        // wait for transitions to complete
        emit('callNext')
    }, 500)

    const { data } = await trackReviewLinkClicked(
        props.slug,
        props.item.link,
        false,
        undefined
    )
    shortlinkSlug.value = data.linkSlug
})

const copyComment = (link: string | undefined) => {
    copyToClipboard(reviewComment.value)
    showGoReviewButton.value = true

    const timer = setInterval(function () {
        if (countdownSeconds.value <= 1) {
            clearInterval(timer)
            visitReviewPage(link)
        }
        countdownSeconds.value--
    }, 1000)
}

const visitReviewPage = (link: string | undefined) => {
    window.open(link, '_blank')
    trackReviewLinkClicked(props.slug, link, true, shortlinkSlug.value)
}
</script>

<style scoped lang="less">
@import '~@/styles/palette.less';
@import '~@/styles/rain/variables.less';

.survey-review-link {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 40px;
    background-color: #ffffff;
    position: relative;

    &--before-click,
    &--after-click {
        width: 300px;
        text-align: center;
        margin: 10px auto;

        p.body1 {
            text-align: center;
            width: 200px;
            margin: 0px auto;
        }
    }

    &--button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 230px;
        background-color: #4394d3;
        border-radius: @borderRadius-md;
        border: 1px solid #4394d3;
        padding: 14px 10px;
        gap: 8px;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        //color: @white;
        margin: 20px auto 0;
        cursor: pointer;

        p {
            color: @white;
        }
    }
}
</style>
